/**
 * Der Review-Reiter in der URL — Lesen und Schreiben an EINER Stelle.
 *
 * 🔴 Warum als Paar (gemeldet 25.08.2026 von Paul: „Man kann hier anomalien gar
 * nicht anklicken"): beim Einbau des Anomalien-Reiters wurde nur die Leseseite
 * erweitert. `setChannel` kannte weiterhin genau einen Sonderfall —
 * `projects` — und schob alles andere in einen `else`-Zweig, der `tab`
 * **löscht**. Der Klick schrieb also nichts, die Ansicht sprang zurück auf
 * E-Mails, und der Reiter sah aus, als wäre er tot.
 *
 * Dieselbe Familie wie die drei Buchungsdialoge und die zwei Frontend-Listen
 * beim Aktions-Katalog: eine Fachlichkeit, zwei Stellen, eine davon vergessen.
 * Deshalb hier zusammen — wer einen Reiter ergänzt, ergänzt ihn für beide
 * Richtungen oder für keine.
 */

// „interne" (#13): die internen Aufgaben des Büros, dieselbe Liste wie auf
// der eigenen Seite.
export const CHANNELS = ["emails", "projects", "anomalien", "interne"] as const
export type Channel = (typeof CHANNELS)[number]

/** Der Standard-Reiter steht NICHT in der URL — `/review` bleibt sauber. */
export const STANDARD: Channel = "emails"

export function tabAusSuche(search: URLSearchParams): Channel {
  const roh = search.get("tab") || ""
  return (CHANNELS as readonly string[]).includes(roh) ? (roh as Channel) : STANDARD
}

export function sucheMitTab(search: URLSearchParams, ziel: Channel): URLSearchParams {
  const next = new URLSearchParams(search)
  next.delete("id")
  if (ziel === STANDARD) next.delete("tab")
  else next.set("tab", ziel)
  // Typ- und Status-Filter gehören zum Projekte-Reiter. Wer ihn verlässt,
  // soll sie nicht mit in eine Ansicht schleppen, die sie nicht kennt.
  if (ziel !== "projects") {
    next.delete("typ")
    next.delete("status")
  }
  return next
}
